import gql from 'graphql-tag'

export default gql`
	query listClosingsShopStatistics($filter: closingsShopStatisticsFilterArgs!) {
		cashAssist {
			listClosingsShopStatistics(filter: $filter) {
				name
				total
				clientCount
				productCount
				cancellationsCount
				currency {
					name
					present
					difference
					exchangeRate
					presentConverted
					cashInTransit
					amount
					amountConverted
				}
				taxes {
					percent
					sales
					MWSt
					total
				}
				paymentMethods {
					name
					count
					amount
				}
				coupons {
					name
					count
					amount
				}
				specialSales{
					name
					count
					amount
				}
			}
		}
	}
`
